import { render, staticRenderFns } from "./SettingsEmailTemplateEditorToolbar.vue?vue&type=template&id=2b80999e"
import script from "./SettingsEmailTemplateEditorToolbar.vue?vue&type=script&lang=ts"
export * from "./SettingsEmailTemplateEditorToolbar.vue?vue&type=script&lang=ts"
import style0 from "./SettingsEmailTemplateEditorToolbar.vue?vue&type=style&index=0&id=2b80999e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports